import areaInfoApi from '@/api/areaInfo'

export async function isOnetimeTypeAlphaAvailable(store) {
  try {
    const me = await store.dispatch('user/getMe')
    const zipcode = me.send_addr_zipcode || ''
    if (!zipcode) {
      return false
    }
    const { data } = await areaInfoApi.getAreaInfo({
      zipcode,
      is_onetime: 1,
    })
    return data && data.is_valid_onetime
  } catch (error) {
    console.error('Failed to fetch area info for onetime plan A:', error)
    return false
  }
}
